import type { FiCatalogResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";

import ViewType from "@app/scene/dashboard/enum/ViewType";
import Scope from "@app/types/dashboard/Scope";

import getDashboardPath from "./getDashboardPath";

// Deep link that opens one chart in Field Insights, keeping the reader's scope.
const getChartPathname = (scope: Scope, chartId: FiCatalogResponse["id"]): string =>
  `${getDashboardPath(scope)}/${ViewType.EXECUTIVE_SUMMARY}?fiChartId=${chartId}`;

export default getChartPathname;
